<template>
    <div class="page-auth">
        <div class="login-page">
            <div class="hidden bg-transparent lg:flex flex-col items-center justify-center">
                <p class="text-white text-4xl text-center w-5/6">Connexion LDAP</p>
            </div>
            <div class="content-form flex flex-col items-center justify-center bg-transparent h-full">
                <div class="mx-auto grid w-4/5 md:w-3/4 gap-6 bg-white py-8 px-3 rounded-15">
                    <div class="grid gap-2 text-center justify-items-center items-center ">
                        <div class="w-3/4 mb-3 flex justify-center">
                            
                            <img class="logo-img" :src="logoUrl"
                            alt="cyberforceacademy logo" v-if="isLogoUrl"  >
                            <img class="" src="../../assets/auth/images/spec-brand-1.svg"
                            alt="cyberforceacademy logo" v-else  >
                        </div>
                        <!-- <h1 class="text-4xl font-[500] text-spect">
                            Connexion LDAP
                        </h1> -->
                        <!-- <p class="text-balance">
                            Entrez vos identifiants LDAP pour vous connecter
                        </p> -->
                        
                        <!-- Error Display -->
                        <div v-if="errorMessage" class="w-full bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                            <p class="font-medium">{{ errorMessage }}</p>
                        </div>
                        
                        <!-- LDAP Login Form -->
                        <form class="grid gap-3 px-4 w-full" @submit.prevent="handleSubmit">
                            <div class="w-full">
                                <label class="block font-medium text-left text-gray-700 mb-1">Nom d'utilisateur</label>
                                <input
                                type="text"
                                v-model="formData.username"
                                class="w-full px-4 py-2 input input-bordered ui-input"
                                :class="{ 'ui-input--error': errors.username }"
                                placeholder="Entrez votre nom d'utilisateur"
                                />
                                <p v-if="errors.username" class="text-red-500 text-sm mt-1 text-left">{{ errors.username }}</p>
                            </div>

                            <!-- Password -->
                            <div class="w-full">
                                <label class="block text-left font-medium text-gray-700 mb-1">Mot de passe</label>
                                <div class="relative w-full">
                                    <input
                                    :type="showPassword ? 'text' : 'password'"
                                    v-model="formData.password"
                                    class="w-full px-4 py-2 input input-bordered ui-input"
                                    placeholder="mot de passe"
                                    :class="{ 'ui-input--error': errors.password }"
                                    />
                                    <span class="absolute right-2 top-3 cursor-pointer" @click="showPassword = false" v-if="showPassword" ><i class="fa fa-eye-slash"></i></span>
                                    <span class="absolute right-2 top-3 cursor-pointer" @click="showPassword = true" v-if="!showPassword" ><i class="fa fa-eye"></i></span>
                                </div>
                                <p v-if="errors.password" class="text-red-500 text-sm mt-1 text-left">{{ errors.password }}</p>
                            </div>
                            
                            <button
                                type="submit"
                                class="w-full flex items-center justify-center gap-3 bg-spect text-white py-3 rounded-6 hover:bg-opacity-90 transition-colors btn-disable"
                                :disabled="isSubmitting || !isFormValid"
                            >
                                <span v-if="isSubmitting" class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></span>
                                <span>
                                    Connexion
                                </span>
                            </button>
                            
                            <div class="text-center mt-2">
                                <a href="/login" class="text-accent text-sm">
                                    ← Retour à la connexion
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { getAPI } from '@/axios-api.js'

export default {
    name: 'LDAPLogin',
    data() {
        return {
            formData: {
                username: '',
                password: '',
                organization_code: '',
            },
            errors: {
                username: null,
                password: null,
            },
            isSubmitting: false,
            errorMessage: '',
            showPassword: false,
        }
    },
    computed: {
        isFormValid() {
            return this.formData.username && this.formData.password && this.formData.organization_code;
        },
        isLogoUrl: {
            get() {
                const logo = localStorage.getItem("domainLogo");
                return logo && logo !== "null" && logo !== "undefined" && logo.trim() !== "";
            },
            set(value) {
                console.log(value)
            }
        },
        logoUrl() {
            const logo = localStorage.getItem("domainLogo");
            if (logo && logo !== "null" && logo !== "undefined" && logo.trim() !== "") {
                return logo;
            }
            return "../../assets/auth/images/spec-brand-1.svg"
        }
    },
    methods: {
        validateForm() {
            this.errors = {
                username: null,
                password: null,
            };
            let isValid = true;

            if (!this.formData.username || this.formData.username.trim() === "") {
                this.errors.username = 'Le nom d\'utilisateur est obligatoire.';
                isValid = false;
            }

            if (!this.formData.password || this.formData.password.trim() === "") {
                this.errors.password = 'Le mot de passe est obligatoire.';
                isValid = false;
            }

            if (!this.formData.organization_code || this.formData.organization_code.trim() === "") {
                this.errorMessage = 'Le code d\'organisation est manquant.';
                isValid = false;
            }

            return isValid;
        },
        
        async handleSubmit() {
            this.errorMessage = '';
            
            if (!this.validateForm()) {
                return;
            }

            this.isSubmitting = true;
            try {
                const payload = {
                    username: this.formData.username,
                    password: this.formData.password,
                    organization_code: this.formData.organization_code,
                };
                
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}sso/ldap/ldap-login/`, payload);
                
                if (response.status === 200 || response.status === 201) {
                    const data = response.data;
                    
                    if (data.requires_registration === true) {
                        if (data.redirect_url) {
                            window.location.href = data.redirect_url;
                        } else {
                            this.errorMessage = data.message || 'Veuillez compléter votre profil pour continuer.';
                        }
                        return;
                    }
                    
                    if (data.requires_registration === false && data.tokens && data.user) {
                        const tokens = data.tokens;
                        const userData = data.user;
                        
                        if (tokens.access) {
                            localStorage.setItem('token', tokens.access);
                        }
                        if (tokens.refresh) {
                            localStorage.setItem('refresh_token', tokens.refresh);
                        }
                        
                        if (userData.id) localStorage.setItem('user', userData.id);
                        if (userData.firstname) localStorage.setItem('firstname', userData.firstname);
                        if (userData.lastname) localStorage.setItem('lastname', userData.lastname);
                        if (userData.type_account) localStorage.setItem('type_account', userData.type_account);
                        if (userData.role) localStorage.setItem('role', userData.role);
                        if (userData.organisation) localStorage.setItem('organisation', userData.organisation);
                        if (userData.code_organisation) localStorage.setItem('code_organisation', userData.code_organisation);
                        if (userData.service) localStorage.setItem('service', userData.service);
                        
                        if (userData.organisation) {
                            try {
                                const orgResponse = await getAPI.get(`organisations/${userData.organisation}/`);
                                if (orgResponse.status === 200) {
                                    const primary = orgResponse.data.primary_color;
                                    const secondary = orgResponse.data.secondary_color;
                                    localStorage.setItem("primary_color", primary || "#0cbcc6");
                                    localStorage.setItem("secondary_color", secondary || "#132c4e");
                                }
                            } catch (error) {
                                console.warn('Could not fetch organization colors:', error);
                            }
                        }
                        
                        window.location.href = '/dashboard';
                    } else {
                        this.errorMessage = data.message || 'Réponse inattendue du serveur.';
                    }
                } else {
                    this.errorMessage = 'Erreur lors de la connexion LDAP.';
                }
            } catch (error) {
                console.error('LDAP login error:', error);
                if (error.response) {
                    const errorData = error.response.data;
                    this.errorMessage = errorData?.message || errorData?.error || errorData?.detail || errorData?.non_field_errors?.[0] || 'Erreur lors de la connexion LDAP.';
                    
                    if (error.response.status === 400) {
                        if (errorData?.username) {
                            this.errorMessage = `Nom d'utilisateur: ${Array.isArray(errorData.username) ? errorData.username[0] : errorData.username}`;
                        } else if (errorData?.password) {
                            this.errorMessage = `Mot de passe: ${Array.isArray(errorData.password) ? errorData.password[0] : errorData.password}`;
                        } else if (errorData?.organization_code) {
                            this.errorMessage = `Code d'organisation: ${Array.isArray(errorData.organization_code) ? errorData.organization_code[0] : errorData.organization_code}`;
                        }
                    } else if (error.response.status === 401) {
                        this.errorMessage = 'Identifiants invalides. Veuillez vérifier votre nom d\'utilisateur et mot de passe.';
                    } else if (error.response.status === 404) {
                        this.errorMessage = 'Organisation non trouvée. Vérifiez le code d\'organisation.';
                    }
                } else if (error.request) {
                    this.errorMessage = 'Erreur de connexion. Vérifiez votre connexion internet et réessayez.';
                } else {
                    this.errorMessage = 'Une erreur inattendue s\'est produite. Veuillez réessayer.';
                }
            } finally {
                this.isSubmitting = false;
            }
        },
        async fetchOrganizationLogo() {
            try {
                const rootUrl = window.location.host;
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}organisations/organisation_details`, {
                    url_access: rootUrl
                });
                if (response.status === 200) {
                    const data = response.data;
                    if (data.logo && data.logo !== "null" && data.logo !== "undefined") {
                        localStorage.setItem("domainLogo", data.logo);
                    } else {
                        localStorage.removeItem("domainLogo");
                    }
                }
            } catch (error) {
                console.warn('Could not fetch organization logo:', error);
            }
        }
    },
    async mounted() {
        // Extract organization_code from URL parameter
        const params = new URLSearchParams(window.location.search);
        const orgCode = params.get('org_code');
        
        if (orgCode) {
            this.formData.organization_code = decodeURIComponent(orgCode);
        } else {
            this.errorMessage = 'Code d\'organisation manquant dans l\'URL.';
        }
        
        // Fetch organization logo if available
        await this.fetchOrganizationLogo();
    },
    async beforeRouteEnter(to, from, next) {
        try {
            const rootUrl = window.location.host;
            const response = await axios.post(`${process.env.VUE_APP_BASE_URL}organisations/organisation_details`, {
                url_access: rootUrl
            });
            if (response.status === 200) {
                const data = response.data;
                if (data.logo && data.logo !== "null" && data.logo !== "undefined") {
                    localStorage.setItem("domainLogo", data.logo);
                } else {
                    localStorage.removeItem("domainLogo");
                }
            }
        } catch (error) {
            console.warn('Could not fetch organization logo:', error);
        }
        next();
    }
}
</script>

<style lang="scss" scoped>
@use "../../assets/scss/tailwinds.scss";
</style>

